<template>
  <div>
    <a-form style="margin: 40px auto 0;">
      <result title="操作成功" :is-success="true" style="max-width: 560px;">
        <div class="information">
          <a-row>
            <a-col :sm="8" :xs="24">充值金额：</a-col>
            <a-col :sm="16" :xs="24">
              <span class="money">{{formMoney}}</span> 元
            </a-col>
          </a-row>
        </div>
        <div slot="action">
          <a-button type="primary" @click="finish">再充一笔</a-button>
          <a-button style="margin-left: 8px" @click="goBackList">返回列表</a-button>
        </div>
      </result>
    </a-form>
  </div>
</template>

<script>
import { Result } from '@/components'

export default {
  name: 'Step3',
  components: {
    Result
  },
  data() {
    return {
      formMoney: this.$parent.$parent.money,
      loading: false
    }
  },
  methods: {
    finish() {
      this.$emit('finish')
    },
    goBackList() {
      this.$emit('goBackList')
    }
  }
}
</script>
<style lang="less" scoped>
.information {
  line-height: 22px;

  .ant-row:not(:last-child) {
    margin-bottom: 24px;
  }
}
.money {
  font-family: 'Helvetica Neue', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 14px;
}
</style>
